var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPowerpoint = function SvgPowerpoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.258 15.576H9.655V9.669h2.55c1.312 0 2.191.831 2.191 2.088 0 1.272-.902 2.065-2.25 2.065h-.888v1.754Zm0-4.626v1.627h.566c.562 0 .9-.315.9-.82 0-.507-.338-.807-.9-.807h-.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.727 2.364a2.363 2.363 0 0 0-2.364 2.363v14.545a2.364 2.364 0 0 0 2.364 2.364h10.545a2.363 2.363 0 0 0 2.364-2.364V8.183a.606.606 0 0 0-.177-.428L14.245 2.54a.606.606 0 0 0-.429-.177h-7.09Zm-.814 1.549c.216-.216.509-.337.814-.337h6.84l4.857 4.858v10.838a1.152 1.152 0 0 1-1.152 1.152H6.727a1.151 1.151 0 0 1-1.152-1.152V4.727c0-.305.122-.598.338-.814Z"
  }))));
};
export default SvgPowerpoint;